import component from "./GameTaskEditor";
export default component;
